// @flow strict

import * as React from 'react';
import { Link } from 'react-router-dom';

import type { State } from './state-list.js';
import selectPageStyles from './select-page.css';
import buttonStyles from './button.css';
import arrowForwardSvg from './images/ic_arrow_forward_24px.svg';
import svgImageFn from './svg-image.jsx';
import iconStyles from './icons.css';
import AldSelection from './ald-selection.jsx';

// we don't supply an icon style here so the button style can control the fill for the pseudo selectors
const ArrowForwardIcon = svgImageFn(
  iconStyles.mediumSquare,
  '',
  arrowForwardSvg
);

type SelectPageProps = {|
  data: State[],
  onOptionsSelection: (string, string, string) => void,
|};

type SelectPageState = {|
  nextLinkEnabled: boolean,
  selectedGradeId: ?string,
  selectedPartnerId: ?string,
  selectedSubjectId: ?string,
|};

export class SelectPage extends React.Component<
  SelectPageProps,
  SelectPageState
> {
  constructor(props: SelectPageProps) {
    super(props);
    this.state = {
      nextLinkEnabled: false,
      selectedGradeId: null,
      selectedPartnerId: null,
      selectedSubjectId: null,
    };
  }

  onOptionsSelection: (string, string, string) => void = (
    partnerId: string,
    gradeId: string,
    subjectId: string
  ) => {
    this.setState({
      nextLinkEnabled:
        partnerId !== null && gradeId !== null && subjectId !== null,
      selectedGradeId: gradeId,
      selectedPartnerId: partnerId,
      selectedSubjectId: subjectId,
    });
    this.props.onOptionsSelection(partnerId, gradeId, subjectId);
  };

  render(): React.Node {
    return (
      <main className={selectPageStyles.mainColumn}>
        <h1
          className="nwea-ds-v1-typography-heading-1"
          data-cy="pickOptionsPageHeaderText"
        >
          What would you like to explore?
        </h1>
        <AldSelection
          data={this.props.data}
          onAllDataSelected={this.onOptionsSelection}
          orientation="vertical"
        />
        {/* TODO: pass in route name */}
        <Link
          to={
            this.state.nextLinkEnabled
              ? {
                  pathname: '/display-skills',
                  state: this.state,
                }
              : '#'
          }
          className={buttonStyles.purpleLink}
          data-cy="next-button"
        >
          Next <ArrowForwardIcon />
        </Link>
      </main>
    );
  }
}
